import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector, connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { reduxForm } from "redux-form";
import {
  getFormFieldMetaData,
  blockAppointmentUpsert,
} from "../../../../redux/actions";
import DynamicForm, {
  DynamicSection,
  COMPONENT_TYPES,
} from "../../../../core/generic-form";
import formDataHandler from "../../../util/formDataHandler";
import CustomLoader from "../../../components/custom-component/custom-loader";
const BlockAppointment = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    let data = {
      DynamicForm: [
        {
          FormName: "AppointmentBlockAppointment",
        },
      ],
    };
    dispatch(getFormFieldMetaData(data));
  }, []);

  const { isFetching } = useSelector((state) => {
    const {
      get_form_field_meta_data: { data, isFetching },
    } = state;
    return { isFetching };
  }, shallowEqual);

  const {
    formFields,
    handleSubmit,
    pristine,
    reset,
    submitting,
    onSubmit,
    handleNext,
    handleBack,
    activeStep,
    NextTab,
    ClientId,
  } = props;

  const handleBlockAppointment = (values) => {
    let ObjectData = formDataHandler(values);
    const {
      Title,
      AppointmentDate,
      AppointmentTime,
      AppointmentEndTime,
      PractitionerId,
      OfficeName,
      Status,
      RecurringType,
      MonthlyRecurring,
      RecurringCount,
    } = ObjectData;

    const formData = {
      GroupAppointment: [
        {
          GroupAppointmentId: null,
          Title,
          AppointmentDate,
          AppointmentTime,
          AppointmentEndTime,
          PractitionerId,
          OfficeName,
          Status,
          IsRecurring: RecurringType == "None" ? false : true,
          GroupAppointmentRecurring: [
            {
              GroupAppointmentRecurringId: null,
              RecurringType,
              WeekDays: values?.WeekDays?.toString(),
              MonthlyRecurring,
              RecurringCount,
            },
          ],
        },
      ],
    };
    dispatch(blockAppointmentUpsert(formData));
  };

  return (
    <>
      {isFetching ? (
        <CustomLoader />
      ) : (
        <form
          autoComplete="off"
          onSubmit={handleSubmit(handleBlockAppointment)}
        >
          <div className="enrollment-form staff-form pt-2 pb-2">
            <div className="row pb-5 pl-3 pr-3 pt-3">
              <DynamicForm formFields={formFields} disable={false} />
            </div>
            <div className="text-right">
              <Button
                variant="contained"
                color="secondary"
                //   className={classes.button}
                type="submit"
                //   disabled={pristine || submitting}
              >
                Create
              </Button>
              &nbsp;
            </div>
          </div>
        </form>
      )}
    </>
  );
};

const ReduxBlockAppointment = reduxForm({
  form: "AppointmentBlockAppointment",
  enableReinitialize: true,
})(BlockAppointment);

export default ReduxBlockAppointment;
